import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';
import {withI18n} from 'spa/Components/Context';
import {withRouter, routerShape} from 'react-router';
import { BOOKING_BASE_URL } from 'utils/constants';
import CartWithCountButtonV2 from '@urbanmassage/component-library/lib/CartWithCountButtonV2/CartWithCountButtonV2';

const CartWithCountButton = ({
  basketHasStartsAt,
  basketHasWorker,
  basketServiceCount,
  router,
  tracker,
}, { i18n }) => {
  const [itemCount, setItemCount] = React.useState(0);

  React.useEffect(() => {
    if (basketServiceCount >= 0) {
      setItemCount(basketServiceCount);
    }
    if (basketServiceCount === 0 && (basketHasWorker || basketHasStartsAt)) {
      setItemCount(1);
    }
    tracker.track('Shown Basket Indicator', {
      hasStartsAt: basketHasStartsAt,
      hasWorker: basketHasWorker,
      serviceCount: basketServiceCount,
    });
  }, [basketHasStartsAt, basketHasWorker, basketServiceCount]);

  const onClickBasket = () => {
    tracker.track('Pressed open basket', {
      hasStartsAt: basketHasStartsAt,
      hasWorker: basketHasWorker,
      serviceCount: basketServiceCount,
    });
    router.push(`/${i18n.lc}/${BOOKING_BASE_URL}/basket`);
  };


  return (
    <CartWithCountButtonV2
      ariaLabel={i18n._x('Go to basket', 'Booking Header')}
      onClick={onClickBasket}
      itemCount={itemCount}
    />
  );
};

CartWithCountButton.propTypes = {
  basketHasStartsAt: PropTypes.bool.isRequired,
  basketHasWorker: PropTypes.bool.isRequired,
  basketServiceCount: PropTypes.number.isRequired,
  router: routerShape.isRequired,
  tracker: PropTypes.object.isRequired,
};

export default withRouter(inject(({
  store: {
    basketNew: {
      basketHasStartsAt,
      basketHasWorker,
      basketServiceCount,
    },
    tracker,
  },
}) => ({
  basketHasStartsAt,
  basketHasWorker,
  basketServiceCount,
  tracker,
}))(withI18n(CartWithCountButton)));



// WEBPACK FOOTER //
// ./spa/Pages/BookingNext/Components/CartWithCountButton.jsx